import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent } from '@mui/material'

import {
  DataGrid,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  gridSortedRowIdsSelector,
  GridToolbarContainer,
  gridVisibleSortedRowIdsSelector,
  useGridApiContext,
  GridToolbarExportContainer,
} from '@mui/x-data-grid';
import { createSvgIcon } from '@mui/material/utils';
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectAdminParticipants } from '../../../reducers/admincenter_participants';

import ParticipantMainDialog from './ParticipantMainDialog';
import { participantdemographicClear } from '../../../reducers/admincenter_participantdemographics';
import { participantaddressClear } from '../../../reducers/admincenter_participantaddress';
import { participantphoneClear } from '../../../reducers/admincenter_participantphone';
import { participantmiscClear } from '../../../reducers/admincenter_participantmisc';
import { contextUpsert, selectContextEntities } from '../../../reducers/global_contexts';
/**
 * 
 {
        "RowNum":9223372036854775807,
        "ParticipantID":2147483647,
        "ParticipantGuid":"String content",
        "FirstName":"String content",
        "LastName":"String content",
        "UserName":"String content",
        "GroupID":2147483647,
        "GroupName":"String content",
        "Status":2147483647,
        "StatusDisplay":"String content",
        "BioDOB":"String content",
        "LastHRAStarted":"String content",
        "LastLogin":"String content"
    }
 */
const ParticipantTable = (props) => {
  const TableLocation = props.TableLocation
  const dispatch = useDispatch()
  const Participants = useSelector(state => selectAdminParticipants(state))
  const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);

  const [ParticipantRow, setParticipantRow] = useState({})
  const [showParticipant, setShowParticipant] = useState(false)
  const getFilteredRows = ({ apiRef }) => gridVisibleSortedRowIdsSelector(apiRef);

  const Contexts = useSelector(state => selectContextEntities(state))
  const { showArchivedParticipants } = Contexts

  const ParticipantsToShow = Participants.filter(x => {
    return (
      (
        (
          x.Status === "1"
          || x.Status === true
          || x.Status === 1
        )
        && showArchivedParticipants === false
      )

      || showArchivedParticipants === true
    )
  })


  const ExportIcon = createSvgIcon(
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
    'SaveAlt',
  );
  const handleParticipantEdit = (row) => {
    if (TableLocation === "MERGE PARTICIPANT") {
      dispatch(contextUpsert({ Key: "mergeParticipantGuid", Value: row.ParticipantGuid }))
    } else if (TableLocation === "PARTICIPANT MANAGEMENT") {
      dispatch(participantaddressClear())
      dispatch(participantphoneClear())
      dispatch(participantmiscClear())
      dispatch(participantdemographicClear())
      setParticipantRow(row)
      setShowParticipant(true)
    }
  }

  const handleCloseDialog = () => {
    setShowParticipant(false)
    setParticipantRow({})
    dispatch(participantaddressClear())
    dispatch(participantphoneClear())
    dispatch(participantmiscClear())
    dispatch(participantdemographicClear())
  }

  const CustomToolbar = () => {
    const apiRef = useGridApiContext();

    const handleExport = (options) => apiRef.current.exportDataAsCsv(options);

    const buttonBaseProps = {
      color: 'primary',
      size: 'small',
      startIcon: <ExportIcon />,
    };

    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
        >
          Filtered rows
        </Button>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getUnfilteredRows })}
        >
          Unfiltered rows
        </Button>
      </GridToolbarContainer>
    );
  };


  const columns = [
    { field: "ParticipantGuid", headerName: "Participant Guid", editable: false, flex: 2 }
    , { field: "FirstName", headerName: "First Name", editable: false, flex: 1 }
    , { field: "LastName", headerName: "Last Name", editable: false, flex: 1 }
    , { field: "UserName", headerName: "Username", editable: false, flex: 1 }
    , { field: "GroupName", headerName: "Group Name", editable: false, flex: 1 }
    , { field: "StatusDisplay", headerName: "Status", editable: false, flex: 1 }
    , { field: "LastHRAStarted", headerName: "Last HRA Started", editable: false, flex: 1 }
    , { field: "LastLogin", headerName: "Last Login", editable: false, flex: 1 }
  ]
  return (
    <Box sx={{ height: TableLocation ==="MERGE PARTICIPANT" ? "300px":"500px" }}>
      <DataGrid
        rows={ParticipantsToShow}
        columns={columns}
        getRowId={(row) => row.ParticipantGuid}
        density="compact"
        disableSelectionOnClick
        onRowDoubleClick={(i, x) => handleParticipantEdit(i.row)}
        components={{ Toolbar: CustomToolbar }}
      // pageSize={5}
      // rowsPerPageOptions={[5]}
      // checkboxSelection
      // disableSelectionOnClick
      // experimentalFeatures={{ newEditingApi: true }}
      />
      {TableLocation === "PARTICIPANT MANAGEMENT" && (

        <Dialog

          open={showParticipant}
          onClose={() => { handleCloseDialog() }}
          fullWidth
          maxWidth="lg"
        >
          <DialogContent>
            <Box p={3}>

              <ParticipantMainDialog Participant={ParticipantRow} closeButton={() => handleCloseDialog()} ParticipantTab={props.ParticipantTab}/>
            </Box>
          </DialogContent>
        </Dialog>
      )}
    </Box>
  )

}
export default ParticipantTable